import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';

import BuilderThemeProvider, {
  CONTAINER_TYPE,
  VIEW_AS,
} from 'hb-builder/components/common/BuilderThemeProvider';
import EventCard from 'hb-react/shared/apps/Events/components/EventsIndexContainer/components/EventCard';
import useTimeZoneConfiguration from 'hb-react/shared/hooks/useTimeZoneConfiguration';

const ItemComponent = ({ event, ...other }) => {
  const timeZoneConfiguration = useTimeZoneConfiguration();

  return (
    <BuilderThemeProvider
      containerType={CONTAINER_TYPE.CARD}
      key={event.id}
      viewAs={VIEW_AS.USER}
    >
      <StyledBox>
        <EventCard
          // @ts-expect-error: fix types
          event={event}
          timezoneConfiguration={timeZoneConfiguration}
          {...other}
        />
      </StyledBox>
    </BuilderThemeProvider>
  );
};

export default ItemComponent;

const StyledBox = styled(Box).attrs(() => ({
  display: 'block',
  height: '100%',
  py: 1,
}))``;
